var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"labeled-icon",style:({
    '--labeled-icon-size': _vm.sizeStyle,
    '--labeled-icon-color': _vm.colorStyle
  })},[_c('div',{staticClass:"labeled-icon__container"},[_c('div',{staticClass:"labeled-icon__icon"},[_c('m-icon',{attrs:{"icon":_vm.icon}})],1),_vm._v(" "),_c('span',{staticClass:"labeled-icon__title",attrs:{"title":_vm.label}},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }